'use client';

import { useEffect } from 'react';
import { isPaymateSupported, paymate } from '@/shared/libs/paymate/paymate-plugin';

const PaymateListener = () => {
  useEffect(() => {
    if (!isPaymateSupported() || typeof window === 'undefined') {
      return;
    }

    let isUnmounted = false;

    const setup = async () => {
      const statusListener = await paymate.addListener('paymateStatus', (event) => {
        window.dispatchEvent(
          new CustomEvent('paymate:status', {
            detail: event,
          })
        );

        if (event.status === 'success' || event.status === 'error') {
          void paymate.removeQrImages().catch(() => undefined);
        }
      });

      const errorListener = await paymate.addListener('paymateError', (event) => {
        window.dispatchEvent(
          new CustomEvent('paymate:error', {
            detail: event,
          })
        );
      });

      const returnListener = await paymate.addListener('paymateReturn', (event) => {
        window.dispatchEvent(
          new CustomEvent('paymate:return', {
            detail: event,
          })
        );
      });

      if (isUnmounted) {
        await statusListener.remove();
        await errorListener.remove();
        await returnListener.remove();
      }

      return {
        statusListener,
        errorListener,
        returnListener,
      };
    };

    const listenersPromise = setup();

    return () => {
      isUnmounted = true;
      void listenersPromise.then(async (listeners) => {
        if (!listeners) {
          return;
        }
        await listeners.statusListener.remove();
        await listeners.errorListener.remove();
        await listeners.returnListener.remove();
      });
    };
  }, []);

  return null;
};

export { PaymateListener };
